import { useContext, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'state/hooks';

import { LayerContext } from '../../state/LayerContext';
import { useGetSegmentTranslateQuery } from '../../state/apiSlice';
import {
  selectRouteSelection,
  selectSegmentId,
  setRouteSelection,
  setSelectedSegmentId,
} from '../../state/workflowSlice';
import { routeSelectionIsSavedRoute } from '../common/hooks/useRouteInfo';

function split_segmentId(segmentId: string): {
  segmentSub: string;
  layer_id: number;
} {
  const segmentIdString = String(segmentId);
  const bits = segmentIdString.split('x');
  if (bits.length === 2) {
    return {
      segmentSub: bits[1],
      layer_id: parseInt(bits[0], 10),
    };
  } else {
    return {
      segmentSub: bits[0],
      layer_id: undefined,
    };
  }
}

function needsCrosswalk(layer, segmentId, routeSelection) {
  let doSegmentTranslate = false;
  if (segmentId) {
    if (split_segmentId(segmentId).layer_id !== layer) {
      doSegmentTranslate = true;
    }
  }
  if (routeSelection) {
    for (let i = 0; i < routeSelection.length; i++) {
      if (split_segmentId(routeSelection[i]).layer_id !== layer) {
        doSegmentTranslate = true;
      }
    }
  }
  return doSegmentTranslate;
}

export function useSegmentSelectionCrosswalk() {
  const segmentId = useAppSelector(selectSegmentId);
  const routeSelection = useAppSelector(selectRouteSelection);
  const { layer } = useContext(LayerContext);
  const dispatch = useAppDispatch();

  // If segmentId implies a different layer, request the equivalent
  // segment for the current layer

  let routeSelectionIds = routeSelection;
  if (routeSelectionIsSavedRoute(routeSelection)) {
    routeSelectionIds = undefined;
  }

  const doSegmentTranslate = needsCrosswalk(
    layer,
    segmentId,
    routeSelectionIds,
  );

  let segmentOrRouteIds;
  if (routeSelectionIds) {
    segmentOrRouteIds = routeSelectionIds;
  } else if (segmentId) {
    segmentOrRouteIds = [segmentId];
  }

  const { currentData: newSegmentIds } = useGetSegmentTranslateQuery(
    { routeIds: segmentOrRouteIds, layerId: layer },
    { skip: !segmentOrRouteIds || !doSegmentTranslate || !layer },
  ) as any;

  useEffect(() => {
    if (!newSegmentIds) return;
    if (routeSelectionIds) {
      dispatch(setRouteSelection(newSegmentIds));
      dispatch(setSelectedSegmentId(newSegmentIds[newSegmentIds.length - 1]));
    } else {
      console.log(
        `Setting translated segment selection to ${newSegmentIds[0]}`,
      );
      dispatch(setSelectedSegmentId(newSegmentIds[0]));
    }
  }, [newSegmentIds]);
}
